import {SubmissionState} from "./SubmissionState";

export class ReviewState extends SubmissionState{

}
